import {DashboardCard, Icon, TextRegular} from '@hm/fundamental'
import {mdiInformationOutline} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {MeasurementTypesCard} from '../components/MeasurementTypesCard'
import {useExtendedMeasurementTypesCategories} from '../hooks/useExtendedMeasurementTypesCategories'
import {useMeasurementTypesCategoriesListItems} from '../hooks/useMeasurementTypesCategoriesListItems'

import {
  LayoutSettings,
  PageLayout,
  SettingsHelmet,
  SettingsList,
  SettingsSkeleton
} from '@settings/modules/common/components'
import {RouteName} from '@settings/modules/routing'

export function PageMeasurementTypesSettings(): JSX.Element {
  const {t} = useTranslation()

  const {
    extendedMeasurementTypesCategories,
    unmappedLimsMeasurementTypes,
    isPageLoading,
    limsMeasurementTypes
  } = useExtendedMeasurementTypesCategories()

  const {measurementTypesCategoriesListItems, selectedMeasurementTypesCategory} =
    useMeasurementTypesCategoriesListItems(extendedMeasurementTypesCategories)

  if (isPageLoading || limsMeasurementTypes === undefined) {
    return <SettingsSkeleton />
  }

  if (limsMeasurementTypes.length === 0) {
    return (
      <DashboardCard
        className="flex items-center justify-center gap-2 text-center p-4"
        data-cy="measurement_types_no_lims"
      >
        <Icon path={mdiInformationOutline} />
        <TextRegular>{t('measurementsSettings.noLimsMeasurementTypes')}</TextRegular>
      </DashboardCard>
    )
  }

  return (
    <PageLayout
      title={t('measurementsSettings.qualityMeasurements')}
      data-test-id={`page_${RouteName.MEASUREMENTS}`}
    >
      <SettingsHelmet title={t('measurementsSettings.pageTitle')} />
      <LayoutSettings
        list={
          <SettingsList
            items={measurementTypesCategoriesListItems}
            testId="measurement_types_categories_list"
          />
        }
        details={
          selectedMeasurementTypesCategory !== undefined ? (
            <MeasurementTypesCard
              selectedMeasurementTypesCategory={selectedMeasurementTypesCategory}
              unmappedLimsMeasurementTypes={unmappedLimsMeasurementTypes}
            />
          ) : (
            <></>
          )
        }
      />
    </PageLayout>
  )
}
